export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		document.addEventListener('contextmenu', (event) => {
			if (event.target instanceof HTMLImageElement) {
				event.preventDefault();
			}
		});
	}
});
